import { topicManagement } from "./topicManagement";
import { colors } from "../../stripeColors";
import DetailsIcon from "../../../components/Common/SvgIcons/ManageIcons/DetailsIcon";
import TopicContentIcon from "../../../components/Common/SvgIcons/OrganizeIcons/TopicContentIcon";
import { organize } from "./organize";
import PublishGroupTopicIcon from "../../../components/Common/SvgIcons/OrganizeIcons/PublishGroupTopicIcon";
import { FormattedMessage } from "react-intl";

export let addNewTopic = {
  name: "Add New Subtopic",
  editName: "Edit Subtopic",
  editpath: (tenantName) =>
    `/${tenantName}/organize/topicManagement/editNewTopic`,
  path: (location, params, tenantName) =>
    location?.pathname.includes(addNewTopic.editpath(tenantName))
      ? `${addNewTopic.editpath(tenantName)}/${params?.topicID}`
      : `/${tenantName}/organize/topicManagement/createNewTopic`,
  navLinks: (navigate, tenantName, location, params) => [
    {
      key: 1,
      label: <FormattedMessage id="TOPICMANAGEMENT_TEXT" />,
      path: `/${tenantName}/organize`,
      onClick: () => navigate(`${topicManagement.path(tenantName)}`),
    },
    {
      key: 2,
      label: location?.pathname.includes(addNewTopic.editpath(tenantName)) ? (
        addNewTopic.editName
      ) : (
        // <FormattedMessage id="ADDNEWTOPIC_TEXT" />
        "Add New Subtopic"
      ),
      path: `${location?.pathname}`,
      onClick: () => navigate(`${location?.pathname}`),
    },
  ],

  tiles: (navigate, location, params, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="DETAILS_TEXT" />,
      path: `${addNewTopic.path(location, params, tenantName)}/details`,
      color: colors.green,
      icon: (fill) => <DetailsIcon fill={fill} />,
      isCompleted: false,
      onClick: () =>
        navigate(`${addNewTopic.path(location, params, tenantName)}/details`),
    },
    {
      key: 2,
      label: "Subtopic content",
      path: `${addNewTopic.path(location, params, tenantName)}/topicContent`,
      color: colors.purple,
      icon: (fill) => <TopicContentIcon fill={fill} />,
      isCompleted: false,
      onClick: () =>
        navigate(
          `${addNewTopic.path(location, params, tenantName)}/topicContent`
        ),
    },
    {
      key: 3,
      label: "Publish Subtopic",
      path: `${addNewTopic.path(location, params, tenantName)}/publishNewTopic`,
      color: colors.orange,
      icon: (fill) => <PublishGroupTopicIcon fill={fill} />,
      // isCompleted: false,
      onClick: () =>
        navigate(
          `${addNewTopic.path(location, params, tenantName)}/publishNewTopic`
        ),
    },
  ],
};
